import { categories } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20breathtaking%20editorial%20still%20life%20composition%20featuring%20a%20mix%20of%20modern%20fashion%20essentials%20including%20light%20grey%20suede%20sneakers%20a%20terracotta%20sweater%20a%20camel%20leather%20satchel%20a%20gold%20wristwatch%20and%20round%20tortoiseshell%20sunglasses%20artfully%20arranged%20on%20a%20warm%20sand%20colored%20textured%20surface%20with%20dramatic%20natural%20window%20light%20casting%20long%20elegant%20shadows%20from%20the%20left%2C%20luxury%20fashion%20editorial%20style%2C%20rich%20textures%2C%20warm%20neutral%20palette&width=1800&height=1200&seq=hero-main-v2-2026&orientation=landscape"
        alt="Superbuy spreadsheet curated fashion and lifestyle products"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/20 to-foreground-950/55"></div>

      <div className="relative z-10 w-full px-6 md:px-12 pt-24">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-background-50 leading-tight drop-shadow-lg">
            Best Superbuy<br />Spreadsheet 2026
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-background-50/85 max-w-md leading-relaxed drop-shadow">
            Discover the best finds, trusted sellers, and expert buying guides &mdash; all curated in one place.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-7 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              superbuy spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-7 py-3.5 bg-foreground-900 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              buy it now
            </a>
          </div>

          <div className="mt-12 flex flex-wrap gap-2">
            {categories.slice(0, 8).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full border border-background-50/20 hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </a>
            ))}
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 bg-accent-500/30 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full border border-accent-400/30 hover:bg-accent-500/40 transition-all cursor-pointer whitespace-nowrap"
            >
              + More Categories
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl animate-bounce block"></i>
      </div>
    </section>
  );
}